import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getFullStorySettings, saveFullStorySettings} from 'src/openapi/admin/apis/FullStorySettingsApi';
import {FrequencyUnit as FrequencyUnits} from 'src/openapi/admin/models/FrequencyUnit';
import {useAppDispatch} from 'src/store/hooks';

import type {FullStorySettings} from 'src/openapi/admin/models/FullStorySettings';

export const useFullStorySettings = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(async (signal: AbortSignal) => {
        const response = await apiDispatch(getFullStorySettings({signal}));
        if (response.payload.error && response.payload.data.status === 404) {
            const payload: {success: true, error: false, data: FullStorySettings} = {
                success: true,
                error: false,
                data: {
                    sessionRecordPercentage: 0,
                    samplingFrequency: 0,
                    frequencyUnit: FrequencyUnits.DAYS,
                    editorId: 0,
                    editedAt: '',
                },
            };
            return Promise.resolve({type: '', payload});
        } else {
            return Promise.resolve({type: '', payload: response.payload});
        }
    }, [apiDispatch]);

    const saveDispatchAction = useCallback((
        {editedAt: _editedAt, editorId: _editorId, ...updateSettingsRequest}: FullStorySettings,
        signal: AbortSignal,
    ) => apiDispatch(
        saveFullStorySettings({updateSettingsRequest}, {signal}),
    ), [apiDispatch]);

    return useCommonDataHook({
        initValue: {
            sessionRecordPercentage: 0,
            samplingFrequency: 0,
            frequencyUnit: FrequencyUnits.DAYS,
            editorId: 0,
            editedAt: '',
        },
        getDispatchAction,
        saveDispatchAction,
    });
};
